module.exports = __webpack_public_path__ + "img/websockets.a45c4c13.svg";